import React from 'react';
import { useFormContext } from 'react-hook-form';

import { FIELD_NAME, GetOTPLink, OTPInput as BaseOTPInput } from '@sravni/react-silent-authentication-form';

import { AUTH_FIELD_NAME } from '../../constants';

import type { OTPInputProps } from './interfaces';

const INPUT_NAME = AUTH_FIELD_NAME.OTP;

export const OTPInput = React.forwardRef<HTMLInputElement, OTPInputProps>((props, ref) => {
  const { onGetOTPLinkClick, ...rest } = props;
  const {
    formState: { errors },
  } = useFormContext();
  const error = errors[INPUT_NAME];
  const isErrorExist = typeof error?.message === 'string';

  return (
    <BaseOTPInput
      {...rest}
      ref={ref}
      underInputComponent={
        isErrorExist ? null : (
          <GetOTPLink inputName={(AUTH_FIELD_NAME.OTP as unknown) as FIELD_NAME} onClick={onGetOTPLinkClick} />
        )
      }
    />
  );
});
